import * as React from "react";
import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { env } from "../../properties";
import { isEmpty } from "lodash-es";
import MobileMenuDrawer from "./MobileMenuDrawer";
import PropTypes from "prop-types";

function MobileMenu({ open, setDrawerOpen }) {
  const [selectedMenuItem, setSelectedMenuItem] = useState({});

  useEffect(() => {
    setSelectedMenuItem({});
  }, [open]);

  return (
    <Box sx={{ height: "60%" }}>
      <MobileMenuDrawer
        open={open}
        setDrawerOpen={setDrawerOpen}
        menuItems={env.menuItems}
        setSelectedMenuItem={setSelectedMenuItem}
        parent
      />
      <MobileMenuDrawer
        open={!isEmpty(selectedMenuItem)}
        setDrawerOpen={setDrawerOpen}
        menuItems={selectedMenuItem?.children}
        selectedMenuItem={selectedMenuItem}
        setSelectedMenuItem={setSelectedMenuItem}
      />
    </Box>
  );
}

MobileMenu.propTypes = {
  open: PropTypes.bool,
  setDrawerOpen: PropTypes.func
};

export default MobileMenu;
